import { Pipe, PipeTransform } from '@angular/core';

import { StatusPipeType } from 'src/app/model';

@Pipe({
  name: 'status'
})
export class StatusPipe implements PipeTransform {

  transform(value: number | boolean): StatusPipeType  {
    return Math.floor(+value) ? 'on' : 'off';
  }

}
